// A view's action, wherever the view is drawn (Home's views, BL-189: base.css's Action retired). In the
// office the one primary is a filled Button and the rest are underlined words (Link); in a chat every one
// is a touch Button, 44 tall, as a tap target. Not a component: the views share it, as they share pen.ts.
import type { ReactNode } from 'react';
import type { Host } from '../host.ts';
import { Button } from './Button/Button.tsx';
import { Link } from './Link/Link.tsx';

export function ViewAct({
  surface,
  primary = false,
  onPress,
  children,
}: {
  surface: Host['surface'];
  primary?: boolean;
  onPress: () => void;
  children: ReactNode;
}) {
  if (surface === 'chat')
    return (
      <Button size="touch" variant={primary ? 'primary' : 'secondary'} onPress={onPress}>
        {children}
      </Button>
    );
  return primary ? (
    <Button variant="primary" onPress={onPress}>
      {children}
    </Button>
  ) : (
    <Link onPress={onPress}>{children}</Link>
  );
}

/** "The copilot agent", or "An AI tool, as you" for the person's own tool. */
export const agentName = (key: string) =>
  key.startsWith('user:')
    ? 'An AI tool, as you'
    : `The ${key.replace(/^agent:/, '').replace(/[-_]/g, ' ')} agent`;
